import { Form, InputNumber } from "antd";
import { LabeledField } from "../labeledField/labeledField";

export const JobOriginalOpeningsField = ({
  disabled,
  isFormItem = true,
  extraLabel = null,
  style = {},
}) => {
  const renderField = () => (
    <InputNumber
      min={1}
      className="modalInput w-100"
      placeholder="Enter Openings"
      disabled={disabled}
      style={style}
    />
  );

  if (isFormItem) {
    return (
      <Form.Item
        label="Job Original Openings"
        name="jobOriginalOpenings"
        rules={[
          {
            required: true,
            message: "Please enter job openings!",
          },
        ]}
      >
        {renderField()}
      </Form.Item>
    );
  }

  return (
    <LabeledField label="Job Original Openings" required extra={extraLabel}>
      {renderField()}
    </LabeledField>
  );
};
